<template>
  <div class="ee-model-list">
    <r-title type="title-2" style="margin-bottom: 16px;">
      Выберите модель
    </r-title>
    <div class="ee-model-list-content" v-loading="loading">
      <div class="ee-model-list-search">
        <el-input
          prefix-icon="el-icon-search"
          class="r-input"
          v-model="filter"
          placeholder="Поиск по названию города"
        />
      </div>
      <ul class="ee-model-list-list" v-if="filteredModels.length">
        <li
          class="ee-model-list-item"
          v-for="item in filteredModels"
          :key="item.id"
          @click="changeModel(item)"
        >
          <div class="ee-model-list-item-icon">
            <r-icon name="model" :size="18" />
          </div>
          <div class="pt-model-list-item-info">
            <r-text>{{ item.name }}</r-text>
            <r-text type="caption">
              {{ item.children.length }} внутр. ИД
            </r-text>
          </div>
        </li>
      </ul>
      <div class="ee-model-list-nodata" v-else>
        <r-text type="caption">
          Нет доступных моделей
        </r-text>
      </div>
    </div>
  </div>
</template>

<script>
import { getDatasourcesByDatatype } from "@/utils";

export default {
  data() {
    return {
      models: [],
      model: "",
      filter: "",
      loading: false
    };
  },
  computed: {
    filteredModels() {
      return this.models.filter(
        m => m.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1
      );
    }
  },
  methods: {
    changeModel(model) {
      this.$emit("change-model", model);
    },
    async loadModelList() {
      try {
        this.loading = true;
        const where = [
          {
            field: "datatype",
            op: "=",
            value: "model",
            type: "AND"
          },
          {
            field: "situation_center",
            op: "=",
            value: true,
            type: "AND"
          }
        ];
        const include = { children: {} };
        const models = await getDatasourcesByDatatype(this, where, include);

        this.models = models.filter(
          ds =>
            ds.children.filter(
              l => l.datatype === "stop_points" || l.datatype === "line_routes"
            ).length
        );
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    }
  },
  async created() {
    const { id } = this.$route.query;

    await this.loadModelList();

    if (id) {
      const model = this.models.find(m => m.id === id);

      this.$router.replace({ query: {} });
      this.changeModel(model);
    }
  }
};
</script>

<style lang="scss">
.ee-model-list {
  &-content {
    min-height: 64px;
  }

  &-search {
    margin-bottom: 8px;
  }

  &-list {
    max-height: 35vh;
    overflow: auto;
    background-color: var(--modal_bg) !important;
    border-radius: var(--border-radius);
    padding: 8px 0;
  }

  &-item {
    cursor: pointer;
    border-radius: var(--border-radius);
    display: flex;
    padding: 2px 16px;

    &:not(:last-child) {
      margin-bottom: 8px;
    }

    &-icon {
      margin-right: 12px;
    }

    &:hover {
      background-color: rgba(var(--accent_primary), 0.2);
    }

    &:active {
      background-color: rgba(var(--accent_primary), 0.3);
    }
  }

  &-nodata {
    padding: 16px;
    text-align: center;
  }
}
</style>
